import { buildAppleMusicPreview } from './appleMusicPreview';
import { buildSpotifyPreview } from './spotifyPreview';
import { buildYouTubePreview } from './youtubePreview';
import { SupportedLinkPreview } from './types';

const PREVIEW_BUILDERS = [
  buildAppleMusicPreview,
  buildSpotifyPreview,
  buildYouTubePreview,
];

export const buildSupportedLinkPreview = (url: string): SupportedLinkPreview | null => {
  for (const buildPreview of PREVIEW_BUILDERS) {
    const preview = buildPreview(url);
    if (preview) {
      return preview;
    }
  }

  return null;
};

export const isSupportedLinkPreviewUrl = (url: string): boolean => Boolean(buildSupportedLinkPreview(url));
